

























import { UiTextbox } from '../keen-ui';

export default {
  name: 'users-password',
  components: {
    UiTextbox
  },
  computed: {
    valid: function () {
      if (this.updateMode) {
        return !this.password || (this.passwordIsValid && this.repeatPasswordIsValid);
      } else {
        return this.passwordIsValid && this.repeatPasswordIsValid && !!this.repeatPassword;
      }
    },
    passwordIsValid: function () {
      if (!!this.password) {
        let valid = true;
        for (const condition of this.passwordRules) {
          if (!condition.regex.test(this.password)) {
            valid = false;
            break;
          }
        }
        return valid && this.password.length >= this.minLength;
      }
      return true;
    },
    repeatPasswordIsValid: function () {
      return this.password === this.repeatPassword;
    }
  },
  props: {
    updateMode: Boolean
  },
  data: function () {
    return {
      password: null,
      repeatPassword: null,
      passwordRules: [
        { regex: /[a-z]+/ },
        { regex: /[0-9]+/ }
        /*{ regex: /[A-Z]+/ },
         { regex: /[@$!%*#?&]+/ }*/
      ],
      messages: this.$epb.messages.tools.users,
      minLength: 8
    };
  },
  watch: {
    valid: {
      handler: function (newValue) {
        this.$emit('passwordChange', { 'valid': newValue, 'value': this.password });
      },
      immediate: true
    }
  }
};
